import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { memo, useMemo } from 'react';
import strings from '../../Globalization';
import { useCycleInfo } from '../../contexts/CycleInfo/Context';
import { useUniqueEffect } from '../../hooks';
import { getTranslation } from '../endosystemcycleinfoviews/CriticalParametersTable';
import { ProcessMonitoringStatus } from '../ProcessMonitoringStatus';


const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0
	}
}));
const CriticalParametersTable = () => {
	const { data, setProcessMonitoringValue } = useCycleInfo()


	const criticalParameters = data.CriticalParameters
	const [columns, rows] = useMemo(() => {
		const columns = [
			{ name: 'HeaderLabel', label: strings.Parameter },
			{ name: 'MetricDataProperty', label: strings.Metric },
			{ name: 'ActualDataProperty', label: strings.Actual },
			{ name: 'CriticalParameterIcon', label: strings.CriticalParamenterTitle, align: 'center' }
		];
		const rows = criticalParameters.reduce((acc, curr, i) => {

			const row = [];
			if (curr.HeaderLabel) {
				const unit = curr.UnitHeader ? `(${curr.UnitHeader})` : '';
				row.push(
					<TableCell
						key={`row${i}-HeaderLabel`}
						variant={curr.isTitle ? 'head' : 'body'}
						sx={{
							padding: curr.isTitle || curr.isNotPhaseData ? '6px 16px' : '6px 28px',
						}}
					>
						{`${getTranslation(curr.HeaderLabel)} ${unit}`}
					</TableCell>
				);
				row.push(<TableCell key={`row${i}-Metric`}>{curr.Metric}</TableCell>);
				row.push(<TableCell key={`row${i}-Actual`}>{curr.Actual}</TableCell>);
				row.push(
					<TableCell align="center" key={`row${i}-CriticalParameterIcon`}>
						<ProcessMonitoringStatus CriticalParameterIcon={curr.CriticalParameterIcon} align={'center'} />
					</TableCell>
				);
				acc.push(row);
			}
			return acc;
		}, []);
		return [columns, rows];
	}, [criticalParameters]);

	const validateProcessMonitoringValue = criticalParameters.filter((ele) => {
		return ele.CriticalParameterIcon === 'fa fa-check icon-check';
	});

	useUniqueEffect(() => {
		if (typeof setProcessMonitoringValue === 'function') {
			setProcessMonitoringValue(validateProcessMonitoringValue.length === rows.length);
		}
	}, [rows.length]);
	return (
		<Grid container>
			{rows?.length > 0 ? (
				<TableContainer component={Grid} size={12}>
					<Table size="small" aria-label="Critical parameters table">
						<TableHead>
							<TableRow>
								{columns.map((column, index) => (
									<TableCell align={column?.align} key={`${index}`}>
										{column.label}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{rows.map((row, index) => (
								<StyledTableRow key={`${index}`}>{row}</StyledTableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			) : (
				<Grid size={12}>
					<Box display={'flex'} justifyContent={'center'} textAlign={'center'}>
						<Typography variant="body2" className="text-center">
							{strings.NoParametersAndDataAvailable}
						</Typography>
					</Box>
				</Grid>
			)}
		</Grid>
	);
};

export default memo(CriticalParametersTable);
